import { render, staticRenderFns } from "./RepresentativeTask.vue?vue&type=template&id=0e27c11a&"
import script from "./RepresentativeTask.vue?vue&type=script&lang=js&"
export * from "./RepresentativeTask.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativeTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports